/**
 * @generated SignedSource<<21c8e0c6af7fa229df163e5c75713b89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTable_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableDateRow_data">;
  readonly " $fragmentType": "RoomRatesTable_data";
};
export type RoomRatesTable_data$key = {
  readonly " $data"?: RoomRatesTable_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTable_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTable_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesTableDateRow_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "e07472dce63800f32c5e8161c8bbdc0a";

export default node;
